import { createRouter, createWebHistory } from 'vue-router'
import Home from '../components/Home.vue'
import Upload from '../views/Upload.vue'
import Download from '../views/Download.vue'
import request from '../api/request.js'
import { createLogger } from '../util/logger.js'
import { showDialog } from '../Dialog/index.js'
import { isWeChatBrowser, getQueryParam, getQueryParamFromRouteQuery } from '../util/browser.js'
import uploadStorage from '../util/uploadStorage.js'

const logger = createLogger('Router')

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/upload',
    name: 'Upload',
    component: Upload
  },
  {
    path: '/share',
    name: 'Download',
    component: Download
  }
]

const basePath = import.meta.env.VITE_APP_BASE_PATH || ''
const routerBase = basePath ? basePath : '/'

const router = createRouter({
  history: createWebHistory(routerBase),
  routes
})

// 路由守卫：在每次路由切换时自动登录和获取列表
router.beforeEach(async (to, from, next) => {
  logger.info('路由守卫:', to, from)
  // 检测是否是微信浏览器，如果是则阻止访问并提示
  const isWeChat = isWeChatBrowser()
  if (isWeChat) {

    localStorage.removeItem('lastAuthCode')
    localStorage.removeItem('lastShareCode')

    showDialog({
      title: '不支持微信浏览器',
      message: '为了更好的使用体验，请在浏览器中打开此页面。\n\n请点击右上角菜单，选择"在浏览器中打开"。',
      type: 'warning',
      confirmText: '我知道了'
    })
  }

  // 如果访问首页且带有 share 参数，直接跳转到分享页（search + hash + route.query 多源兼容）
  if (to.path === '/') {
    const shareCode = !isWeChat
      ? (getQueryParam('share') || getQueryParamFromRouteQuery(to.query, 'share') || '')
      : ''
    logger.info('shareCode:', shareCode)
    if (shareCode) {
      localStorage.setItem('lastShareCode', shareCode)
      next('/share')
      return
    }
    
    // 如果访问首页且带有 code 参数，直接跳转到上传页并执行登录逻辑
    const codeParam = !isWeChat
      ? (getQueryParam('code') || getQueryParamFromRouteQuery(to.query, 'code') || '')
      : ''
    logger.info('codeParam:', codeParam)


    const skipCodeParam = sessionStorage.getItem('skipCodeParam') === 'true'
    if (skipCodeParam) {
      // 清除标志
      sessionStorage.removeItem('skipCodeParam')
      logger.info('检测到 skipCodeParam 标志，跳过 code 参数处理')
      next()
      return
    }

    if (codeParam) {
      // 保存 code 到 localStorage
      localStorage.setItem('lastAuthCode', codeParam)
      // 直接跳转到上传页面
      next('/upload')
      return
    }
  }
  
  if (to.path === '/share') {
    const lastAuthCode = localStorage.getItem('lastShareCode')
    const result = await request.autoLoginAndGetList(lastAuthCode, true)
    if (!result.success) {
      logger.error('自动登录和获取列表失败:', result.error)
      sessionStorage.removeItem(uploadStorage.getParamsKey(lastAuthCode))
      showDialog({
        title: '登录失败',
        message: '当前用户异常，请联系商家处理！',
        type: 'error'
      })
    }
  }else if (to.path === '/upload' && !from.name) {
    
    // 检查是否有保存的授权码
    const lastAuthCode = localStorage.getItem('lastAuthCode')
    
    // 静默执行登录和获取列表（不显示错误提示，避免打断用户体验）
    const result = await request.autoLoginAndGetList(lastAuthCode)
        
    if (result.success) {
      logger.info('自动登录和获取列表成功')
      // 将结果存入 sessionStorage（按 code 区分），供 Upload 页面使用
      if (result.uploadParams) {
        sessionStorage.setItem(uploadStorage.getParamsKey(), JSON.stringify(result.uploadParams))
      }
    } else {
      logger.warn('自动登录和获取列表失败:', result.error)
      // 如果失败，清除保存的授权码，让用户重新登录
      sessionStorage.removeItem(uploadStorage.getParamsKey())
      showDialog({
        title: '登录失败',
        message: '当前用户异常，请联系商家处理！',
        type: 'error'
      })
      sessionStorage.setItem('skipCodeParam', 'true')
      next('/?code=' + lastAuthCode)
      return
    }
  }
  // 继续导航
  next()
})

export default router

